
import { computed, defineComponent, markRaw, PropType, ref, watch } from 'vue'
import NlpCard from '@/views/NLP/components/NlpCard.vue'
import { IFileRead } from '@/api/nlp/nlp-api-type'

const KEYWORD_COLOR_MAP: Record<number, string> = {
  0: '#CFB808',
  1: '#14AB11',
  2: '#19B8E4',
  3: '#7519E4',
  4: '#E77E20',
  5: '#194FD9',
  6: '#8E0404',
  7: '#0C4918',
  8: '#E73707',
  9: '#E52EA0',
}

export default defineComponent({
  components: {NlpCard},
  props: {
    content: {
      type: String,
      required: true
    },
    themeWords: {
      type: Array as PropType<IFileRead.ThemewordListItem[]>,
      required: true
    },
    params: {
      type: Object as PropType<Pick<IFileRead.SummaryReqParams, 'summaryCount'>>,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update-abstract-count'],
  setup (props, { emit }) {
    const countOptions = [
      300,
      500,
      800,
      1000,
      1500,
      2000,
      2500,
      3000,
    ]
    function countChange (count: number) {
      emit('update-abstract-count', count)
    }

    const displayAbstract = computed(() => {
      let tmp = props.content
      // 只取前10个进行高亮
      // 主题词之间可能存在交集，会出现高优先级被低优先级覆盖的情况，
      // 比如关键词列表：一个人，个人
      // 如果先给 “一个人” 上色
      // 再给“个人”上色
      // 就回出现高优先级的“一个人”的“个人”二字被覆盖
      // 所以从低优先级的主题词开始上色
      props.themeWords
        .slice(0, 10)
        .reverse()
        .forEach((t, idx) => {
          // TODO：重新设计这里的渲染方式
          // TODO： 发现之前渲染的 text 是自己的子集，则先清除格式，再添加格式
          const color = KEYWORD_COLOR_MAP[idx]
          tmp = tmp.replaceAll(t.name ?? '', `<i style="color:${color};font-style: normal;">${t.name}</i>`)
        })

      return tmp
    })

    return {
      countOptions,
      countChange,
      displayAbstract
    }
  },
})
